import React from 'react';
import { createMemoryRouter } from 'react-router-dom';

import { ArticleSidebar } from '../../help-center/components/ArticleSidebar';
import { AppRoutePatterns } from '../../routes';
import { AppLayout } from './AppLayout';

export const router = createMemoryRouter([
  {
    path: '/',
    element: <AppLayout />,
    children: [
      {
        path: AppRoutePatterns.ArticleById,
        element: <ArticleSidebar />,
      },
      {
        path: AppRoutePatterns.ArticleByUri,
        element: <ArticleSidebar />,
      },
      {
        path: '*',
        element: null,
      },
    ],
  },
]);
